export const isElementHasDimension = (
    el: Pick<Element, 'clientWidth' | 'clientHeight'>,
): boolean => {
    return el.clientWidth + el.clientHeight > 0;
};
